import { InformeAnualService } from './../../../services/informe-anual.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, LoadingController } from '@ionic/angular';
import { from } from 'rxjs';
import CONFIG from '../../../config';
@Component({
  selector: 'app-informe-anual',
  templateUrl: './informe-anual.page.html',
  styleUrls: ['./informe-anual.page.scss'],
})
export class InformeAnualPage implements OnInit {
  //subir ot masivas
  endpoint=CONFIG.API
  archivoSeleccionado: any = {}
  cargaArchivo: boolean = false;//carga de ordenes
  uploadedFiles: any = []
  rowsInformes:any=[]
  constructor( public loadingController: LoadingController,
    private route: ActivatedRoute, public router: Router,
    public alertController: AlertController,
    public informeAnualService:InformeAnualService) { }

  ngOnInit() {
    this.getData();
  }

  fileChange(element, index) {
    if (index == 0) {//Si es solo un archivo
      this.archivoSeleccionado = element.target.files[0];
      this.cargaArchivo = true;
    }
  }
  getData(){
    this.informeAnualService.obtenerInformes()
    .then(data => this.rowsInformes=data);
  ;
  }
  // setForm() {
  //   this.formulario = {}
  //   this.formularioInventario = {}
  //   this.elementosInventario = [];
  // }
  async guardarArchivo() {
    const loading = await this.loadingController.create({
      message: 'Guardando datos...',
      spinner: "lines"
    });
    await loading.present();
    //Función para subir un solo arvchivo
    if (this.archivoSeleccionado.name) {
      let formData = new FormData();
      
      let usuario: any = JSON.parse(window.localStorage.getItem('usuario'))
      formData.append('file', this.archivoSeleccionado, this.archivoSeleccionado.name);
      formData.append('id_usuario', usuario.id_usuario);
      this.informeAnualService.guardarInforme(formData)
        .then((data) => {
          this.cargaArchivo = false;
          this.archivoSeleccionado = {};
          loading.dismiss();
          this.getData()
          //this.setForm();
          this.mensajes("Éxito", "", "Se ha guardado el informe con éxito.")
          // this.router.navigate(['/menuAutocontrol/informe-anual']);
        })
        .catch(err => {
          console.log(err);
          loading.dismiss();
          this.mensajes("Algo salió mal", "Por favor intenta de nuevo", "No se ha podido cargar")
        }).finally(()=>{

          loading.dismiss();
        })
    } else {
      loading.dismiss();
      this.mensajes("Algo salió mal", "", "No hay ningún archivo seleccionado")
    }
  }

  async mensajes(header, subHeader, message) {
    const alert = await this.alertController.create({
      header: header,
      subHeader: subHeader,
      message: message,
      buttons: ['Aceptar']
    });

    await alert.present();
  }
  verReporte(archivo){
    window.open(CONFIG.API + '/verReporte/'+archivo)
  }
}


